import * as React from "react";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Table from "@mui/joy/Table";
import Sheet from "@mui/joy/Sheet";
import Typography from "@mui/joy/Typography";
import CircularProgress from "@mui/joy/CircularProgress";
// import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from "@mui/icons-material/Search";

import { DialogTitle, IconButton, Modal, ModalDialog, Stack } from "@mui/joy";
import { start } from "repl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useGetFiEmpLocationQuery } from "../services/vendor/VendorApi";
import { apiBaseUrl, invoiceStatusOptionsEmployee } from "../utils/constants";
import { IReportData } from "../utils/types";
import { displayOptional, formatDateTable } from "../utils/utils";
import MultiSelectCheckboxDropdown from "../components/MultiSelectCheckdownDropbox";
import { useGetBtsReportsQuery, useGetBtsReportswithSearchQuery, useGetFetchLocationQuery, useGetReportsQuery } from "../services/invoices/InvoiceApiSlice";
import { SelectInput } from "../utils/input";
import ClearIcon from '@mui/icons-material/Clear';
import { Backdrop } from "@mui/material";

const ITEMS_PER_PAGE = 10;

export default function BtsReportsTable() {

    const pernr = localStorage.getItem("employee_id");
    const [cwclocationList, setCwcLocationList] = React.useState<any>([]);
    const [filterInputs, setFilterInputs] = React.useState({ location: '', startDate: '', endDate: '', po_number: '', status: '' });
    const [page, setPage] = React.useState(1);
    const [searchQuery, setSearchQuery] = React.useState('');

    const navigate = useNavigate();

    const {
        data: dropdownList,
        error,
        isSuccess,
        isError,
    } = useGetFiEmpLocationQuery(null);


    React.useEffect(() => {
        if (dropdownList) {

            var list = dropdownList?.d?.results?.map((item) => {
                return {
                    value: item?.pa,
                    label: `${item?.pa} - ${item?.pa_txt}`,
                };
            })
            setCwcLocationList([...list, { value: 'alll', label: 'All' }]);
        }
    }, [dropdownList]);
    const tableHeaders: Array<{
        id: keyof IReportData | 'Zstatus' | 'ZTRESDCODE' | 'ZREFID' | 'tradsstatus' | 'btsno' | 'invoicetype' | 'po_number' | 'ProcumentType' | 'Appointeddate' | 'AcceptanceDate' | 'EnterpriseType' | 'Ownedby' | 'TrendsAvailable' | 'WomenEntrepreneurs' | 'gem' | 'msme' | 'PaidProcessDays' | 'PaidDate' | "action" | 'req_type' | 'entry_type' | 'po_num' | 'view' | 'doc_num' | 'utr_num' | 'Inv_Ref' | 'srno' | 'InvoiceId' | 'InvoiceNo' | 'InvoiceDate' | 'GEMInvoiceNo' | 'InvoiceAmount' | 'InvoiceReceivedDate' | 'services' | 'Division' | 'RegionName';
        label: string;
        minWidth: number;
        numeric?: boolean;
        disableSort?: boolean;
    }> = [
            { id: "srno", label: "Sr No.", minWidth: 50 },
            { id: "InvoiceId", label: "Invoice Id", minWidth: 130 },
            { id: "btsno", label: "BTS No.", minWidth: 130 },
            { id: "InvoiceNo", label: "Invoice No", minWidth: 130 },
            { id: "invoicetype", label: "Invoice Type", minWidth: 130 },
            { id: "InvoiceAmount", label: "Invoice Amount", minWidth: 130 },
            { id: "InvoiceDate", label: "Invoice Date", minWidth: 130 },
            { id: "InvoiceReceivedDate", label: "Invoice Received Date", minWidth: 175 },
            { id: "status", label: "Status", minWidth: 105 },
            { id: "PaidDate", label: "Paid Date", minWidth: 105 },
            { id: "PaidProcessDays", label: "Paid / Process Days", minWidth: 170 },
            { id: "GEMInvoiceNo", label: "GEM Invoice No.", minWidth: 130 },
            { id: "po_number", label: "PO Number", minWidth: 130 },
            { id: "services", label: "Services", minWidth: 130 },
            { id: "Division", label: "Division", minWidth: 130 },
            { id: "RegionName", label: "Region Name", minWidth: 130 },
            { id: "msme", label: "MSME", minWidth: 130 },
            { id: "gem", label: "GEM", minWidth: 130 },
            { id: "vendor_name", label: "Vendor Name", minWidth: 130 },
            { id: "WomenEntrepreneurs", label: "Women Entrepreneurs", minWidth: 150 },
            { id: "TrendsAvailable", label: "Trends Available", minWidth: 150 },
            { id: "Ownedby", label: "Ownedby", minWidth: 150 },
            { id: "EnterpriseType", label: "Enterprise Type", minWidth: 150 },
            { id: "AcceptanceDate", label: "Acceptance Date", minWidth: 150 },
            { id: "Appointeddate", label: "Appointed date", minWidth: 150 },
            { id: "ProcumentType", label: "Procument Type", minWidth: 150 },
            // { id: "tradsstatus", label: "Treds Status", minWidth: 100 },
            { id: "ZREFID", label: "TReDS Ref. ID", minWidth: 150 },
            { id: "ZTRESDCODE", label: "TREDS Payment", minWidth: 150 },
            { id: "Zstatus", label: "TReDS Inv. Status", minWidth: 150 },

        ];
    const [isOpen, setisOpen] = React.useState(false);
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");
    const [locationList, setLocationList] = React.useState([]);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [entries, setEntries] = React.useState<any>([]);
    const [pagination, setPagination] = React.useState<any>(null);

    const clearFilter = () => {
        setFilterInputs({ location: "", startDate: '', endDate: '', po_number: '', status: '' });
        setEntries([]);
        setPagination(null)
    };

    const [debouncedFilters, setDebouncedFilters] = React.useState(filterInputs);
    const { data: fetchLoction } = useGetFetchLocationQuery(0);

    React.useEffect(() => {
        if (fetchLoction?.data) {
            const list = fetchLoction?.data.map((item) => {
                return { label: item.location_txt, value: item.Location_code };
            });
            setLocationList([...list]);
        }
    }, [fetchLoction])


    const isSearchActive = React.useMemo(
        () => !!(debouncedFilters.location || debouncedFilters.startDate.length > 0 || debouncedFilters.endDate),
        [debouncedFilters]
    );

    const searchApiArgs = {
        location: debouncedFilters.location,
        startDate: debouncedFilters.startDate,
        endDate: debouncedFilters.endDate,
        po_number: debouncedFilters.po_number,
        status: debouncedFilters.status,
        pernr: pernr,
    };

    Object.keys(searchApiArgs).forEach((key) => {
        if (searchApiArgs[key] == null || searchApiArgs[key] === "") {
            delete searchApiArgs[key];
        }
    });

    const { data: searchData, isLoading, isFetching: isSearchingData, error: errorEmployeeInvoices } = useGetBtsReportswithSearchQuery("page=" + page + "&per_page=10" + searchQuery, { skip: searchQuery === '' });

    React.useEffect(() => {
        if (searchData?.data) {
            setEntries([...searchData?.data]);
            setPagination({ ...searchData?.pagination });
        }
    }, [searchData])


    const onHandleSearch = async () => {
        try {
            var sdate = filterInputs.startDate.split("-").reverse().join("-");
            var edate = filterInputs.endDate.split("-").reverse().join("-");
            const pernr = localStorage.getItem("employee_id");
            var payload = "&pernr=" + pernr + "&start_date=" + sdate + "&end_date=" + edate + "&location=" + (filterInputs.location === 'alll' ? '' : filterInputs.location) + "&po_number=" + filterInputs.po_number + "&status=" + filterInputs.status;
            setSearchQuery(payload);

        } catch (err) {

        }
    }


    const handleBtsNoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilterInputs({ ...filterInputs, [event.target.name]: event.target.value });
    };


    const handleInvoiceStatusChange = (name: any, value: any) => {
        setFilterInputs({ ...filterInputs, [name]: value });
    }

    const handleDownloadExcel = () => {

        let formatted1 = ''
        let formatted2 = '';

        console.log(filterInputs)
        if (filterInputs?.startDate) {
            var date1 = filterInputs?.startDate.split("-");
            formatted1 = `${date1[2]}-${date1[1]}-${date1[0]}`;
        }
        if (filterInputs?.endDate) {
            var date2 = filterInputs?.endDate.split("-");
            formatted2 = `${date2[2]}-${date2[1]}-${date2[0]}`;
        }

        const url = apiBaseUrl + '/api/bts/download-excel?status=' + filterInputs?.status + '&po_number=' + filterInputs?.po_number + '&location=' + (filterInputs.location === 'alll' ? '' : filterInputs.location) + '&start_date=' + formatted1 + '&end_date=' + formatted2 + "&pernr=" + localStorage.getItem("employee_id");

        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank"
        a.click();
        URL.revokeObjectURL(url);
        setisOpen(false);
    }

    const renderFilters = () => (
        <>

            <Box sx={{ width: "inherit" }}>
                <SelectInput
                    disabled={isLoading}
                    name="location"
                    label="Search by Location"
                    value={filterInputs.location}
                    options={cwclocationList || []}
                    onChange={handleInvoiceStatusChange}
                    placeholder="Select Location"
                />
            </Box>
            <FormControl size="sm" sx={{ width: "inherit" }} >
                <FormLabel sx={{ fontSize: '14px', fontWeight: 700 }}>Search by Date From</FormLabel>
                <Input disabled={isLoading} placeholder="Search BTS No." type="date" name="startDate" value={filterInputs.startDate} onChange={handleBtsNoChange} style={{ height: '37px' }} />
            </FormControl>
            <FormControl size="sm" sx={{ width: "inherit" }}>
                <FormLabel sx={{ fontSize: '14px', fontWeight: 700 }}>Search by Date To</FormLabel>
                <Input disabled={isLoading} placeholder="Search BTS No." type="date" name="endDate" value={filterInputs.endDate} onChange={handleBtsNoChange} style={{ height: '37px' }} />
            </FormControl>
            <FormControl size="sm" sx={{ width: "inherit" }} >
                <FormLabel sx={{ fontSize: '14px', fontWeight: 700 }}>Search by PO Number</FormLabel>
                <Input disabled={isLoading} placeholder="Search by PO Number" name="po_number" value={filterInputs.po_number} onChange={handleBtsNoChange} style={{ height: '37px' }} />
            </FormControl>
            <Box sx={{ width: "inherit" }}>
                <SelectInput
                    name="status"
                    disabled={isLoading}
                    label="Search by Status"
                    value={filterInputs.status}
                    options={invoiceStatusOptionsEmployee || []}
                    onChange={handleInvoiceStatusChange}
                    placeholder="Select Status"
                />
            </Box>
            <FormControl size="sm" sx={{ width: "inherit" }} >
                <FormLabel sx={{ fontSize: '14px', fontWeight: 700 }}>&nbsp;</FormLabel>
                <Box sx={{ display: 'flex', gap: '25px' }}>
                    <Button sx={{ width: "37px", height: "35px", marginBottom: '2px' }} onClick={onHandleSearch} disabled={isLoading}><SearchIcon /></Button>
                    {(filterInputs?.location !== "" || filterInputs?.startDate?.length !== 0 || filterInputs?.endDate !== "") && (
                        <Button onClick={clearFilter} sx={{ maxWidth: "fit-content" }} size="sm" variant="soft" color="danger" disabled={isLoading}>
                            <ClearIcon />
                        </Button>
                    )}
                    {/* <IconButton aria-label="delete" size="lg" onClick={() => onHandleDownloadExcel()} sx={{ minHeight: 'unset', width: '40px', height: '31px' }}>
                    <DownloadIcon fontSize="inherit" style={{ transform: 'scale(1.5)' }} />
                    </IconButton> */}
                </Box>

            </FormControl>



        </>
    );

    if (errorEmployeeInvoices) {
        return (
            <Typography color="danger" sx={{ p: 4, textAlign: "center" }}>
                Error loading data.
            </Typography>
        );
    }

    console.log(entries)

    return (
        <React.Fragment>
            <>
                <Box sx={{ display: 'flex' }}>
                    <Box
                        className="SearchAndFilters-tabletUp"
                        sx={{
                            borderRadius: "sm",
                            pt: 1,
                            pb: 1,
                            display: { xs: "flex", sm: "grid" },
                            flexDirection: { xs: "column", sm: "row" },
                            gridTemplateColumns: { sm: "repeat(7, 1fr)" },
                            gridTemplateRows: { sm: "repeat(1, auto)" },
                            gap: 2,
                            width: "100%",
                            flexWrap: "wrap",
                            "& > *": { minWidth: { xs: "120px", md: "160px" } },
                        }}
                    >
                        {renderFilters()}
                    </Box>
                    <FormControl size="sm" sx={{ width: "inherit" }} >
                        <FormLabel sx={{ fontSize: '14px', fontWeight: 700 }}>&nbsp;</FormLabel>
                        {entries?.length > 0 && <Box>

                            <IconButton disabled={isLoading} aria-label="delete" size="lg" onClick={() => handleDownloadExcel()} sx={{ minHeight: 'unset', width: '40px', height: '31px' }}>
                                <DownloadIcon fontSize="inherit" style={{ transform: 'scale(1.5)' }} />
                            </IconButton>
                        </Box>}
                    </FormControl>
                </Box>

            </>


            {entries?.length > 0 && <Sheet
                className="OrderTableContainer"
                variant="outlined"
                sx={{
                    width: "100%",
                    borderRadius: "sm",
                    flexShrink: 1,
                    overflow: "auto",
                    minHeight: 300,
                }}
            >
                <Table
                    aria-labelledby="tableTitle"
                    stickyHeader
                    hoverRow
                    sx={{
                        "--TableCell-headBackground": "var(--joy-palette-background-level1)",
                        "--Table-headerUnderlineThickness": "1px",
                        "--TableRow-hoverBackground": "var(--joy-palette-background-level1)",
                    }}
                >
                    <thead>
                        <tr>
                            {tableHeaders.map((headCell) => (
                                <th
                                    className="heading-3"
                                    key={headCell.id}
                                    style={{
                                        width: headCell.minWidth,
                                        minWidth: headCell.minWidth,
                                        padding: "12px 6px",
                                        textAlign: "center",
                                    }}
                                >
                                    <Typography fontWeight="lg" level="body-sm">
                                        {headCell.label}
                                    </Typography>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>


                        {

                            entries?.map((invoice: any, index: any) => (
                                <tr key={invoice.id || invoice.bts_no}>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{(index + 1)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.invoice_id)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.id)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.inv_no)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{invoice?.invoice_type}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.inv_amount)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{formatDateTable(invoice?.inv_date)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{formatDateTable(invoice?.inv_received_date)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{invoice?.status}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{formatDateTable(invoice?.paid_date)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.paid_process_day)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.gem_inv_no)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.po_number)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.services)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.division)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.region)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.msme)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.gem)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.vendor_name)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.women_entrepreneur)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.trends_avail)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.Ownedby)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.enterpise_type)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{formatDateTable(invoice?.appointed_date)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{formatDateTable(invoice?.acceptance_date)}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{displayOptional(invoice?.procument_type)}</Typography>
                                    </td>
                                    {/* <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{invoice?.invStatus}</Typography>
                                    </td> */}

                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{invoice?.Zrefid}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{invoice?.Ztredscode}</Typography>
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        <Typography level="body-xs">{invoice?.Zstatus}</Typography>
                                    </td>


                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </Sheet>}

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pt: 2,
                }}
            >
                {entries?.length > 0 && <Box sx={{ display: "flex", gap: 1 }}>
                    <Button size="sm" variant="outlined" onClick={() => { setPage(page - 1); }} disabled={!pagination || pagination?.page <= 1}>
                        Previous
                    </Button>
                    <Button size="sm" variant="outlined" onClick={() => { setPage(page + 1); }} disabled={!pagination || pagination?.page >= pagination?.pages}>
                        Next
                    </Button>
                </Box>}
            </Box>


            <Modal open={isOpen} onClose={() => setisOpen(false)}>
                <ModalDialog>
                    <DialogTitle>Download Report</DialogTitle>


                    <Stack spacing={2}>
                        <FormControl>
                            <FormLabel>Start Date</FormLabel>
                            <Input type="date" onChange={(e) => setStartDate(e.target.value)} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>End Date</FormLabel>
                            <Input type="date" onChange={(e) => setEndDate(e.target.value)} />
                        </FormControl>
                        <Button onClick={() => handleDownloadExcel()}>Download</Button>
                    </Stack>
                </ModalDialog>
            </Modal>

            <Backdrop
                className="globalLoading"
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={isSearchingData}
            >
                <CircularProgress />
            </Backdrop>
        </React.Fragment>
    );
}



function getFiscalYearCode(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 1–12

    var fiscalYearStart: any = '';
    if (month >= 4) {
        fiscalYearStart = year;
    }
    else {
        fiscalYearStart = year - 1;
    }
    return fiscalYearStart;
}